module.exports = __webpack_public_path__ + "img/install-icon.4909be62.webp";